import { render } from "./Box.vue?vue&type=template&id=86c6a3f0"
import script from "./Box.vue?vue&type=script&lang=js"
export * from "./Box.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rezaradfar/Sites/vue-udemy-projects/vue-movie-rating/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__